import React from 'react';
import WhatsappFloat from '../components/WhatsappFloat';
import { Helmet } from 'react-helmet-async';

const TermosUso = () => (
  <>
    <Helmet>
      <title>Termos de Uso | MicroCodie</title>
      <meta name="description" content="Leia os Termos de Uso do site MicroCodie e entenda as condições para navegação e utilização dos nossos serviços." />
      <meta property="og:title" content="Termos de Uso | MicroCodie" />
      <meta property="og:description" content="Leia os Termos de Uso do site MicroCodie e entenda as condições para navegação e utilização dos nossos serviços." />
      <meta property="og:type" content="website" />
      <meta property="og:url" content="https://www.microcodie.com.br/termos-uso" />
      <meta property="og:image" content="/logo192.png" />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content="Termos de Uso | MicroCodie" />
      <meta name="twitter:description" content="Leia os Termos de Uso do site MicroCodie e entenda as condições para navegação e utilização dos nossos serviços." />
      <meta name="twitter:image" content="/logo192.png" />
      <link rel="canonical" href="https://www.microcodie.com.br/termos-uso" />
    </Helmet>
    <div className="container" style={{ padding: '3rem 0', maxWidth: 800, margin: '6rem auto 0 auto' }}>
      <h1>Termos de Uso</h1>
      <p>Estes Termos de Uso regulam o acesso e uso do site da MicroCodie. Ao utilizar nossos serviços, você concorda com as condições abaixo.</p>
      <h2>1. Uso do Site</h2>
      <p>O usuário se compromete a utilizar o site de forma ética, respeitando a legislação vigente e os direitos de terceiros.</p>
      <h2>2. Propriedade Intelectual</h2>
      <p>Todo o conteúdo deste site, incluindo textos, imagens, logotipos e marcas, é protegido por direitos autorais e pertence à MicroCodie ou a seus parceiros.</p>
      <h2>3. Responsabilidades</h2>
      <p>Não nos responsabilizamos por danos decorrentes do uso inadequado do site ou por indisponibilidades temporárias.</p>
      <h2>4. Modificações</h2>
      <p>Podemos alterar estes Termos de Uso a qualquer momento. As alterações entrarão em vigor a partir da publicação nesta página.</p>
      <h2>5. Contato</h2>
      <p>Em caso de dúvidas sobre estes Termos, entre em contato pelo e-mail: contato@microcodie.com.br</p>
    </div>
    <WhatsappFloat />
  </>
);

export default TermosUso; 